import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RoleService} from '../../../services/role.service';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormBuilder} from '@angular/forms';
import {CompanyService} from '../../services/company.service';
import {PartnerWalletService} from '../../../partner-wallet.service';
import {MultiCrudDataSource} from '../../../table-datasouces/multi-crud.datasource';
import {toDateTimeString} from '../../../providers/app-date-adapter';
import {PartnerWallet} from '../../../dto/partnerWallet';
import {ToastService} from 'angular-toastify';
import {Company} from '../../../dto/company';
import {CreateWalletDialogComponent} from '../create-wallet-dialog/create-wallet-dialog.component';
import {ContentRowField} from '../../../shared/content-row/content-row.component';

@Component({
  selector: 'app-wallet-list',
  templateUrl: './wallet-list.component.html',
  styleUrls: ['./wallet-list.component.css']
})
export class WalletListComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private partnerWalletService: PartnerWalletService,
    private changeDetectorRefs: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    public companiesService: CompanyService,
    private _toastService: ToastService,
    private dialog: MatDialog,
  ) { }

  isBusy = false;
  isLoading = false;
  isImporting = false;

  public companies: Company[] = [];
  public selectedCompanyId: number|null;


  dataSource = new MultiCrudDataSource(this.partnerWalletService);
  columns = [
    {columnDef: 'status', header: 'Status', cellColor: row => {
        if ( row.isClosed ) {
return 'red';
}
        return 'forestgreen';
      }, icon: row => {
        if ( row.isClosed ) {
return 'cancel';
}
        return 'check';
    }}  as ContentRowField<PartnerWallet>,
    {columnDef: 'createDate', header: 'Created', cell: (row: PartnerWallet) => `${toDateTimeString(row.createDate) || ''}`}  as ContentRowField<PartnerWallet>,
    {columnDef: 'companyId', header: 'Company', cell: (row: PartnerWallet) => row.company ? `${row.company.name}` : '-' }  as ContentRowField<PartnerWallet>,
    {columnDef: 'walletNumber', header: 'Number', cellColor: row => {
        if ( row.isClosed ) {
return 'red';
}
        return null;
      }, cell: (row: PartnerWallet) => {
      if ( row.isClosed ) {
return row.walletNumber + ' (closed)';
}
      if ( !row.revolutAccountId || !row.walletIban ) {
return row.walletNumber;
}
      return row.walletNumber + ' ⚡️';
    } } as ContentRowField<PartnerWallet>,
    {columnDef: 'customName', header: 'Name', cell: (row: PartnerWallet) => row.customName } as ContentRowField<PartnerWallet>,
    {columnDef: 'balance', header: 'Balance', cellColor: row => {
        if ( row.balance < 0 ) {
return 'red';
}
        return null;
      }, cell: (row: PartnerWallet) => `${row.balance.formatMoneyCcy(row.currencyCode)}`} as ContentRowField<PartnerWallet>,
  ] as ContentRowField<PartnerWallet>[];

  isAdmin(): boolean {
 return this.roleService.hasRoles('admin');
}
  isPartner(): boolean {
 return this.roleService.hasRoles('partner');
}
  isWallet(): boolean {
 return this.roleService.hasRoles('wallet');
}

  deleteEnabled() {
    return false;
  }

  editEnabled() {
    return false;
  }

  ngOnInit() {
    if ( !this.isWallet()) {
this.loadCompanies();
}
  }

  loadCompanies() {
    this.companiesService.getAll().subscribe(data => {
      this.companies = data.data;
    });
  }

  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles('admin');
  }
  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }

  getRowClass = (item: PartnerWallet): string => '';

  getViewLink = (item: PartnerWallet): string => item.id.toString();

  getEditLink = (item: PartnerWallet): string => item.id.toString() + '/edit';


  View(partnerWallet: PartnerWallet) {
    this.router.navigate([partnerWallet.id], {relativeTo: this.route});
  }

  Edit(partnerWallet: PartnerWallet) {
    this.router.navigate([partnerWallet.id, 'edit'], {relativeTo: this.route});
  }

  public createWallet() {

    this.dialog.open(CreateWalletDialogComponent, {
      data: {}
    })
      .afterClosed()
      .subscribe((result: PartnerWallet) => {

        const name = result.customName;
        const currencyCode = result.currencyCode;

        if ( !name) {
          this._toastService.warn('Wallet creation aborted');
          return;
        }

        if ( !currencyCode) {
          this._toastService.warn('Wallet creation aborted');
          return;
        }

        this.isBusy = true;
        const w = new PartnerWallet();
        w.customName = name;
        w.currencyCode = currencyCode;
        if ( this.isAdmin() ) {
w.companyId = this.selectedCompanyId;
}

        this.partnerWalletService.createWallet(w).subscribe(data => {
          this.isBusy = false;
          this.isLoading = true;
          this._toastService.success('Wallet ' + name + ' was created');
          this.dataSource.loadData();
          this.isLoading = false;

        }, err => {
          this.isBusy = false;
          this.isLoading = false;
          this._toastService.error(err.error.message || err.message || err.error || err);
        });
      });
  }

}
